import { PortfolioRepo as portfolioRepo } from '@services/portfolio.repo';
import { PortfolioUtilities as portfolioUtilities } from '@common/portfolio.utilities';
import { portfolioSelectorService } from '../../portfolioSelector';
import * as echarts from 'echarts';

class PortfolioMauritiusCashController {
  chartCashHeight: any;
  public cashItems: any;
  public cashTotal: any = 0;

  public cashPieChart: any;
  public cashPieChartOptions: any;
  public cashPieChartData: any;

  /** @ngInject */
  constructor(private portfolioRepo: portfolioRepo, private portfolioUtilities: portfolioUtilities, private portfolioSelectorService: portfolioSelectorService,
    private $timeout: ng.ITimeoutService, private notifyjs) {

    var that = this;

    this.portfolioSelectorService.registerCallback('portfolio.mauritius.cash', () => { this.updateData() }); // Need to wrap it in a fat arrow functiom to get the correctly scoped this

    portfolioRepo.getPortfolioCashItems('LOCAL')

    that.updateData();

  }

  public formatCurrency(currency: string) {
    if (!this.portfolioSelectorService.isLoading && currency != null && currency.length > 0) {
      return this.portfolioUtilities.formatCurrency(currency);
    } else {
      return "";
    }
  }

  getCashPercentage(cash: any) {
    return (cash.marketValue / this.cashTotal) * 100;
  }

  public scrollToElement(elementId: string) {
    var that = this;
    this.$timeout(function () { that.portfolioUtilities.scrollToElement(elementId); }, 220);
  }
  public initialisePieChart() {
    // need to put the initialisation of the pie chart in a function because the dom element is not available till
    // the time you have clicked on the pie chart tab.
    var that = this;
    that.cashPieChart = echarts.init(document.getElementById('cash-pie-chart'));
    that.cashPieChartOptions = {
      tooltip: {
        trigger: 'item',
        formatter: "{b} : {d}%"
      },
      color: ['#489830', '#6cac59', '#91c182'],
      series: {
        type: 'pie',
        radius: ['40%', '70%'],
        center: ['50%', '50%'],
        labelLine: {
          normal: {
            show: true
          }
        },
        data: that.cashPieChartData
      }

    }
    that.cashPieChart.setOption(that.cashPieChartOptions);

  }

  // Cash data
  updateData() {
    var that = this;
    this.portfolioSelectorService.setIsLoading(true);
    that.portfolioRepo.getPortfolioCashItems(this.portfolioSelectorService.getSelectedCurrency(), "LOCAL", this.portfolioSelectorService.getSelectedPortfolios())
      .then((val) => {
        that.cashItems = val.data;

        that.scrollToElement('cash');

        that.cashPieChartData = new Array();
        for (var s of this.cashItems) {
          this.cashTotal += s.marketValue;

          that.cashPieChartData.push({
            name: s.cashAccount.name,
            value: s.marketValue
          });
        }
        this.portfolioSelectorService.setIsLoading(false);
      })
      .catch((err) => {
        this.portfolioSelectorService.setIsLoading(false);
        this.notifyjs("The cash data for the selected portfolios could not be loaded. Please try again later or contact the System Administrator.", "error");
      })
  }
}

export const portfolioMauritiusCash: angular.IComponentOptions = {
  template: require('../portfolio.mauritius.cash/portfolio.mauritius.cash.html'),
  controller: PortfolioMauritiusCashController
}



// WEBPACK FOOTER //
// ./src/app/portfolio/portfolio.mauritius/portfolio.mauritius.cash/portfolio.mauritius.cash.ts